<div class="action-header mt-5 color-light font-medium">
  {{ '#ESL_LINK.ESL_CODE.MANUAL_INPUT' | translate }}
</div>
<soft-input
  [placeholder]="'#ESL_LINK.ESL_CODE.PLACEHOLDER' | translate"
  [(value)]="value"
  (keydown.enter)="onSubmit()"
></soft-input>
<button
  class="soft-button primary w-full mt-2 min-height-button rounded"
  [disabled]="!value || value === ''"
  (click)="onSubmit()"
>
  <span class="pt-1">{{ '#ESL_LINK.ESL_CODE.SUBMIT' | translate }}</span>
</button>

<div class="action-header uppercase mt-4 color-light font-medium">
  {{ '#ESL_LINK.ESL_CODE.OR' | translate }}
</div>
<div
  class="soft-card rounded border-primary flex flex-row flex-nowrap pb-4 pt-4 pr-4 pl-4 center-v mb-1 cursor-pointer"
  (click)="startScan()"
>
  <i class="fa-regular fa-barcode-scan fa-3x mr-2 ml-1"></i>
  <div class="flex flex-col justify-center ml-3">
    <span class="text-bold">{{ '#ESL_LINK.ESL_CODE.SCAN_HEADER' | translate }}</span>
    <span class="color-light">
      {{ '#ESL_LINK.ESL_CODE.SCAN_DESCRIPTION' | translate }}
    </span>
  </div>
</div>
